module.exports = __webpack_public_path__ + "static/media/Empty-Box.b9a3d0dd.svg";